<template>
  <div class="dashboard-container">
    <component :is="currentRole" ref="mychild" :data="data" />
  </div>
</template>
<script>
import consumer from "./template/consumer";
import contracted from "./template/contracted";
import custom from "./template/custom";
import caowei from "./template/caowei";
import axios from 'axios';
export default {
  name: "customer",
  components: { consumer, contracted, custom, caowei },
  data() {
    return {
      currentRole: "",
      qrcode: null,
      data: {
        resdata: {},
      },
    };
  },
  // 有没有admin然后选择首页模板
  created() {
    this.qrcode = this.$route.params.qrcode || this.$route.query.q;

    // 直接写死广州默认坐标与地区，移除腾讯地图jsonp请求
    const resdata = {
      ip: "",
      location: {
        lat: 23.1291, // 广州纬度
        lng: 113.2644 // 广州经度
      },
      ad_info: {
        province: "广东省",
        city: "广州市",
        district: ""
      }
    };

    this.$http
        .post(`/api/openmt/tencentapi/gettencentkey`, { mtKey: 'tencet_consumer_applet', appkey: '1', sign: '1' })
        .then((res1) => {
          // 不再调用腾讯地图，直接使用上面写死的广州数据
          this.$http
              .get(`/api/out/qrcode/qrcodecount?qrcode=${this.qrcode}&pcquery=false&ip=${resdata.ip}&lat=${resdata.location.lat}
            &lng=${resdata.location.lng}&province=${resdata.ad_info.province}&city=${resdata.ad_info.city}&district=${resdata.ad_info.district}`)
              .then((res) => {
                // if (res.data.scanRedirect) {
                //   window.location.href =
                //     "http://h5.mms.mtyt.fun/h5/wechat?q=1," +
                //     res.data.qrcode +
                //     "," +
                //     res.data.qrcodeParent+res.data.product_code+res.data.product_name;
                // }
                if (!res.data) {
                  this.data.resdata = res;
                  this.currentRole = "consumer";
                  return;
                }
                switch (res.data.qlist[0].templateId) {
                  case 1:
                    this.currentRole = "consumer";
                    this.data.resdata = res;
                    break;
                  case 2:
                    this.currentRole = "contracted";
                    this.data.resdata = res;
                    break;
                  case 3:
                    this.currentRole = "custom";
                    this.data.resdata = res;
                    break;

                  default:
                    this.data.resdata = res;
                    this.currentRole = "consumer";
                    break;
                }
              })
        })
  },
};
</script>
<style lang="scss">
.main{
  background: url('~@/assets/img/stbg.png') no-repeat center top;
  background-size: 100% auto;
  background-color: #dd1821;
  min-height:130vh;
}
</style>
